module.exports = {
  ROOT       : 0,
  GROUP      : 1,
  POSITION   : 2,
  SET        : 3,
  RANGE      : 4,
  REPETITION : 5,
  REFERENCE  : 6,
  CHAR       : 7,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ret/lib/types.js
// module id = Z8U4
// module chunks = 0